import {Document, Image, Link, Page, StyleSheet, Text, View} from "@react-pdf/renderer";
import Logo from "@/images/glenbrook225-white-text.png";

const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        backgroundColor: "#ffffff",
        fontFamily: "Helvetica",
    },
    header: {
        backgroundColor: "#631d79",
        padding: 40,
        alignItems: "center",
        justifyContent: "center",
        minHeight: 160,
    },
    logoContainer: {
        marginBottom: 20,
        alignItems: "center",
    },
    logoImage: {
        height: 87.5,
        width: 162.5,
    },
    logoSubtext: {
        color: "white",
        fontSize: 18,
        fontWeight: "bold",
        letterSpacing: 3,
    },
    title: {
        color: "white",
        fontSize: 24,
        fontWeight: "bold",
        textAlign: "center",
    },
    content: {
        flex: 1,
        padding: 60,
        alignItems: "center",
        justifyContent: "flex-start",
    },
    scanTitle: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#333333",
        marginBottom: 30,
        textAlign: "center",
    },
    qrContainer: {
        border: "3px solid #e5e7eb",
        padding: 5,
        backgroundColor: "white",
        marginBottom: 30,
        borderRadius: 8,
    },
    qrPlaceholder: {
        width: 150,
        height: 150,
        backgroundColor: "#000000",
        alignItems: "center",
        justifyContent: "center",
    },
    qrText: {
        color: "white",
        fontSize: 10,
        textAlign: "center",
    },
    instructionsContainer: {
        marginBottom: 20,
    },
    instruction: {
        fontSize: 14,
        color: "#4b5563",
        textAlign: "center",
        marginBottom: 8,
        lineHeight: 1.4,
    },
    footer: {
        fontSize: 12,
        color: "#6b7280",
        textAlign: "center",
        marginTop: "auto",
        paddingBottom: 20,
    },
    footerLink: {
        fontFamily: "Courier",
        fontSize: 11,
    },
});
type Props = {
    qrCode: string;
    feeName: string;
    feeLink: string;
};
const FeePdf = ({feeLink, feeName, qrCode}: Props) => {
    return (
        <Document title={feeName} creator="Glenbrook High School" creationDate={new Date()}>
            <Page size="LETTER" style={styles.page}>
                {/* Header */}
                <View style={styles.header}>
                    <View style={styles.logoContainer}>
                        <Image style={styles.logoImage} src={Logo} />
                    </View>
                    <Text style={styles.title}>{feeName}</Text>
                </View>

                {/* Content */}
                <View style={styles.content}>
                    <Text style={styles.scanTitle}>Scan to Purchase</Text>

                    {/* QR Code Placeholder */}
                    <View style={styles.qrContainer}>
                        <View style={styles.qrPlaceholder}>
                            <Image src={qrCode} />
                        </View>
                    </View>

                    {/* Instructions */}
                    <View style={styles.instructionsContainer}>
                        <Text style={styles.instruction}>
                            1. Open your phone's camera or QR code scanner
                        </Text>
                        <Text style={styles.instruction}>2. Point at the QR code above</Text>
                        <Text style={styles.instruction}>
                            3. Follow the link to complete your purchase
                        </Text>
                    </View>

                    {/* Footer */}
                    <Text style={styles.footer}>
                        Can't scan? Visit:{" "}
                        <Link style={styles.footerLink} src={feeLink}>
                            {feeLink}
                        </Link>
                    </Text>
                </View>
            </Page>
        </Document>
    );
};

export default FeePdf;
